import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { UserRolesState } from "../../../../utils/types";

export const pending = (state: UserRolesState) => {
  state.isLoading = true;
  state.data = null;
  state.isError = false;
};

export const fulfilled = (
  state: UserRolesState,
  action: PayloadAction<Types.ApiResponse>
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: UserRolesState) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
